import { Component } from '@angular/core';

@Component({
    selector: 'app-fallback',
    template: `<p class="alert alert-warning">Oh Snap, something went wrong could not locate the requested route.</p>`,
    standalone: false
})
export class FallbackComponent {
}